export const SAVE_FUEL_SAVINGS = 'SAVE_FUEL_SAVINGS';
export const CALCULATE_FUEL_SAVINGS = 'CALCULATE_FUEL_SAVINGS';

export const GET_PREBOOKING_OFFERING_REQUEST='GET_PREBOOKING_OFFERING_REQUEST';
export const GET_PREBOOKING_OFFERING_SUCCESS='GET_PREBOOKING_OFFERING_SUCCESS';
export const GET_PREBOOKING_OFFERING_FAILURE='GET_PREBOOKING_OFFERING_FAILURE';

export const CREATE_BOOKING_REQUEST='CREATE_BOOKING_REQUEST';
export const CREATE_BOOKING_SUCCESS='CREATE_BOOKING_SUCCESS';
export const CREATE_BOOKING_FAILURE='CREATE_BOOKING_FAILURE';

export const UPDATE_SELECTED_LOCATION_ID='UPDATE_SELECTED_LOCATION_ID';

export const GET_PARKING_PRICE_REQUEST = "GET_PARKING_PRICE_REQUEST";
export const GET_PARKING_PRICE_SUCCESS = "GET_PARKING_PRICE_SUCCESS";
export const GET_PARKING_PRICE_FAILURE = "GET_PARKING_PRICE_FAILURE";

export const CHANGE_BOOKING_FROM_DATE_TIME="CHANGE_BOOKING_FROM_DATE_TIME";
export const CHANGE_BOOKING_TO_DATE_TIME="CHANGE_BOOKING_TO_DATE_TIME";
export const SET_SELECT_OFFERING="SET_SELECT_OFFERING";

export const GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';


export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SET_USER_FROM_LOGIN="SET_USER_FROM_LOGIN";
export const LOGOUT="LOGOUT";
export const RESET="RESET";

export const SELECT_PARKING_OPTIONAL_SERVICE="SELECT_PARKING_OPTIONAL_SERVICE";
export const UPDATE_PRICE="UPDATE_PRICE";
export const UPDATE_USER_DETAIL_INPUT="UPDATE_USER_DETAIL_INPUT";
export const GET_OFFERING_PRICE_REQUEST = "GET_OFFERING_PRICE_REQUEST";
export const GET_OFFERING_PRICE_SUCCESS = "GET_OFFERING_PRICE_SUCCESS";
export const GET_OFFERING_PRICE_FAILURE = "GET_OFFERING_PRICE_FAILURE";
export const SET_SELECT_PRICING="SET_SELECT_PRICING";
export const UPDATE_CARD_NUMBER="UPDATE_CARD_NUMBER";
export const UPDATE_EXPIRY_DATE="UPDATE_EXPIRY_DATE";
export const UPDATE_CVC="UPDATE_CVC";
export const CREATE_USER_REQUEST="CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS="CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE="CREATE_USERE_FAILURE";
export const RESET_FORM="RESET_FORM";


export const CREATE_PAYMENT_REQUEST="CREATE_PAYMENT_REQUEST";
export const CREATE_PAYMENT_SUCCESS="CREATE_PAYMENT_SUCCESS";
export const CREATE_PAYMENT_FAILURE="CREATE_PAYMENT_FAILURE";

export const UPDATE_PAYMENT_REQUEST="UPDATE_PAYMENT_REQUEST";
export const UPDATE_PAYMENT_SUCCESS="UPDATE_PAYMENT_SUCCESS";
export const UPDATE_PAYMENT_FAILURE="UPDATE_PAYMENT_FAILURE";

export const GET_PAYMENT_DETAILS_REQUEST = "GET_PAYMENT_DETAILS_REQUEST";
export const GET_PAYMENT_DETAILS_SUCCESS = "GET_PAYMENT_DETAILS_SUCCESS";
export const GET_PAYMENT_DETAILS_FAILURE = "GET_PAYMENT_DETAILS_FAILURE";
export const RESET_PAYMENT_DETAILS = "RESET_PAYMENT_DETAILS";


export const GET_VEHICLE_LIST_REQUEST = "GET_VEHICLE_LIST_REQUEST";
export const GET_VEHICLE_LIST_SUCCESS = "GET_VEHICLE_LIST_SUCCESS";
export const GET_VEHICLE_LIST_FAILURE = "GET_VEHICLE_LIST_FAILURE";

export const CHECK_VEHICLE_REG_REQUEST = "CHECK_VEHICLE_REG_REQUEST";
export const CHECK_VEHICLE_REG_SUCCESS = "CHECK_VEHICLE_REG_SUCCESS";
export const CHECK_VEHICLE_REG_FAILURE = "CHECK_VEHICLE_REG_FAILURE";
export const ADD_VEHICLE="ADD_VEHICLE";

export const CHECK_SPACE_REQUEST = "CHECK_SPACE_REQUEST";
export const CHECK_SPACE_SUCCESS = "CHECK_SPACE_SUCCESS";
export const CHECK_SPACE_FAILURE = "CHECK_SPACE_FAILURE";








// WEBPACK FOOTER //
// ./src/constants/actionTypes.js